import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';
import { IUpdateNominatingOrganisationRequest } from '../models/nom-org-update';
import { INominatingOrganisation } from '../models/nom-org';

@Injectable({
  providedIn: 'root'
})
export class NomOrgService {

  baseUrl: string = `${environment.servicesUrl.committee}api/nominating-organisations`;

  constructor(
    private http: HttpClient,
  ) { }

  public getNomOrgs(): Observable<IApiResponse<INominatingOrganisation[]>> {
    return this.http.get<IApiResponse<INominatingOrganisation[]>>(this.baseUrl);
  }

  public updateNomOrg(request: IUpdateNominatingOrganisationRequest): Observable<IApiResponse<number>> {
    return this.http.put<IApiResponse<number>>(`${this.baseUrl}/${request.nominatingOrganisationId}`, request);
  }

}
